module.exports = __webpack_public_path__ + "27660e17b09e2ab1ef1a19bf92a1e405.svg";